import { render } from "./swipe_click.vue?vue&type=template&id=4c0f684c"
import script from "./swipe_click.js?vue&type=script&lang=js&external"
export * from "./swipe_click.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__